import axios from "axios";
import { BASE_URL } from "../api";

// Create a public API client for non-authenticated endpoints
const publicApiClient = axios.create({
  baseURL: `${BASE_URL}/api` || "http://localhost:5001/api",
});

export const contactService = {
  // Send contact form
  sendContactForm: async (contactData) => {
    const response = await publicApiClient.post("/contact", contactData);
    return response.data;
  },
};
